import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { message, Select } from 'antd';

// Local Deps
import getContractCenterData from './graphql';
import createRFQ from '../../../graphql/sendRFQ';
import history from '../../../config/history';

const { Option } = Select;

export default function SendRfqHOC(SendRfq) {
  class SendRfqWrapper extends Component {
    static propTypes = {
      auth: PropTypes.instanceOf(Object).isRequired,
      closeRfqModal: PropTypes.func.isRequired,
      closeProcGroupModal: PropTypes.func.isRequired,
      modalRfqOpen: PropTypes.bool.isRequired,
      modalProcGroupVisible: PropTypes.bool.isRequired,
      rfqInput: PropTypes.instanceOf(Object).isRequired,
    };

    state = {
      isLoading: true,
      newRfq: true,
      selectedRfq: null,
      options: [],
    };

    async componentDidMount() {
      this.getContractData(this.props.auth.organizationId);
    }

    getContractData = async organizationId => {
      const data = await getContractCenterData(organizationId);

      const combinedArr = [...data.rfq.drafts, ...data.rfq.submitted];

      const options = [];
      combinedArr.forEach(element => {
        options.push(
          <Option value={element.rfqId}>{element.description}</Option>,
        );
      });

      this.setState({
        options,
      });
    };

    handleOkRfq = async () => {
      let rfq = this.state.selectedRfq;
      let res = null;
      if (this.state.selectedRfq) {
        history.push(`/contractcenter/rfq?rfq=${rfq}`);
      } else {
        res = await createRFQ(this.props.auth.id, this.props.rfqInput);
        const { status } = res;
        if (status !== 'success') {
          // TODO: error Handling
          message.error(
            'Oops, Something Went Wrong While Saving the Quote, Please Try Again and If Problem Persists Contact Support',
          );
        }
        rfq = res.rfqId;
      }

      history.push(`/contractcenter/rfq?rfq=${rfq}`);
    };

    onRadioChange = checked => {
      this.setState({
        newRfq: checked,
        selectedRfq: null,
      });
    };

    onSelectChange = value => {
      this.setState({
        selectedRfq: value,
        newRfq: false,
      });
    };

    render() {
      const { auth, closeRfqModal, closeProcGroupModal, modalRfqOpen } = this.props;
      return (
        <SendRfq
          auth={auth}
          onRadioChange={this.onRadioChange}
          onSelectChange={this.onSelectChange}
          handleOkRfq={this.handleOkRfq}
          closeRfqModal={closeRfqModal}
          closeProcGroupModal={closeProcGroupModal}
          modalRfqOpen={modalRfqOpen}
          {...this.state}
        />
      );
    }
  }

  return SendRfqWrapper;
}



// WEBPACK FOOTER //
// ./src/components/Modals/SendRfq/SendRfqHOC.jsx